<template>
  <div class="q-pa-md row items-start q-gutter-lg">
    <q-card class="my-card bg-secondary text-white" v-for="shop in my_shops" v-bind:key="shop.domain">
      <q-card-section>
        <div class="text-h6"> {{shop.domain}} </div>
      </q-card-section>
      
      <q-card-section class="shopify absolute-center ">
        <!-- <div v-if="shop.shop_type == 'shopify'" class="fab fa-shopify  absolute-bottom "></div> -->
        <div class="fab fa-shopify  absolute-bottom "></div>
      </q-card-section>
    </q-card>
  </div>
  
</template>

<script>

export default {
  created() {
    var shop_url = this.api_url + "/shops/mine";

    this.$http
      .get(shop_url)
      .then((response) => {
        this.my_shops = response.data
      })
      .catch((err) => {
        console.log(err);
      });
  },

  mounted() {
    this.$store.dispatch("setPathName", "/shops");


  },
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      my_shops: []
    };
  },
};
</script>

<style lang="stylus" scoped></style>

<style lang="sass" scoped>
.my-card
  width: 100%
  height: 200px
  max-width: 350px

.shopify
  color: lightgreen
  font-size: 40px
  
</style>



